import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Row, Col, Space } from "antd";
import { Form, Field } from "react-final-form";

import FormGroup from "components/form/formGroup";

import Tarots from "./tarots";
import FastMessages from "./fastMessages";
import Premiums from "./premiums";
import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";

class MessageInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isBigInput: false,
    };
  }

  render() {
    const { isBigInput } = this.state;
    return (
      <Col>
        <Form onSubmit={this.onSubmit}>
          {({ handleSubmit, values, form }) => (
            <>
              <Space style={{ padding: 10 }} wrap>
                {isBigInput ? (
                  <FullscreenExitOutlined
                    style={{ fontSize: 30, color: "var(--adm-color-primary)" }}
                    onClick={() => this.setState({ isBigInput: false })}
                  />
                ) : (
                  <FullscreenOutlined
                    style={{ fontSize: 30, color: "var(--adm-color-primary)" }}
                    onClick={() => this.setState({ isBigInput: true })}
                  />
                )}
                <FastMessages
                  onPress={(body) => this.props.onSubmit({ body })}
                />
                {!!this.props.tarots.length && (
                  <Field
                    name="tarotId"
                    component={Tarots}
                    tarots={this.props.tarots}
                  />
                )}
                <Field
                  name="premiumPurchaseId"
                  placeholder="Select Premium Purchase"
                  component={Premiums}
                  consultantId={this.props.consultantId}
                />
              </Space>
              <Row>
                <Field
                  name="body"
                  component="textarea"
                  style={{
                    flex: 1,
                    fontSize: 18,
                    height: isBigInput ? 200 : 50,
                    borderRadius: 5,
                  }}
                  className="ant-input ant-input-outlined"
                  onFocus={this.props.onFocus}
                  onBlur={this.props.onBlur}
                  onKeyPress={(event) =>
                    event.key === "Enter" &&
                    this.validMessage(values.body) &&
                    handleSubmit(values, form)
                  }
                />
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  disabled={!this.validMessage(values.body)}
                  style={{ height: 50 }}
                >
                  Submit
                </Button>
              </Row>
            </>
          )}
        </Form>
      </Col>
    );
  }

  onSubmit = (values, form) => {
    if (!values.body) return;

    this.props.onSubmit(values);
    form.reset();
  };

  validMessage = (message) => {
    const CYRILLIC_PATTERN = /[\u0400-\u04FF]/;
    return !CYRILLIC_PATTERN.test(message);
  };
}

MessageInput.propTypes = {
  onSubmit: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  saveTempMessage: PropTypes.func,
  tarots: PropTypes.array,
};

MessageInput.defaultProps = {
  onSubmit: null,
  onFocus: () => null,
  onBlur: () => null,
  saveTempMessage: () => null,
  tarots: [],
};

export default MessageInput;
